<template>
	<div class="on_sale_table">
		<div class="table" >
			<div class="d-flex a-center w-100 j-sb" style="box-sizing: border-box;height: 80px;border-radius: 0.375rem;background-color: #FFFFFF;margin-bottom: 20px;padding: 0 40px;">
				<div class="d-flex a-center j-sb" style="width: 20rem;position: relative;font-weight: 600;box-sizing: border-box;padding: 0 0.375rem;">
					<div class="d-flex flex-column a-center" :class="curIndex==index?'tab-active':'tab-pt'" @click="tabclick(index)"
					style="box-sizing: border-box;cursor: pointer;" v-for="(item,index) in tabList" :key="index">
						<div style="font-size: 20px;">{{item.tabnum}}</div>
						<div style="margin-top: 9px;">{{item.tabname}}</div>
					</div>
					<div class="cld-box" :style="curIndex==0?'left:6%':curIndex==1?'left:46%':'left:84%'"></div>
				</div>
				<div class="d-flex a-center">
					<div class="d-flex a-center" style="color: #000000;font-size: 1.25rem;font-weight: 600;margin-right: 2.5rem;">
						<div style="color: #888888;font-size: 0.75rem;font-weight: 600;padding-right: 0.8rem;">总成交(次):</div>{{percent}}
					</div>
					<el-button type="primary" size="mini" @click="performance" style="background-color: #1E69FF;">业务员绩效表</el-button>
				</div>
			</div>
			<el-table ref="multipleTable" :height="880" :border="false" :data="tableData" tooltip-effect="dark"
				style="font-size: 0.75rem;" :header-cell-style="{color:'#000000'}" @selection-change="handleSelectionChange">
				<el-table-column align="center" type="selection" label="">
				</el-table-column>
				<el-table-column align="center" prop="custom_id" label="序号" show-overflow-tooltip>
					<template slot-scope="scope">
						<div>{{scope.$index}}</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="status" label="客户类型" show-overflow-tooltip>
					<template slot-scope="scope">
						<div>{{scope.row.status==0?'准客户':'客户' }}</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="name" label="客户称呼" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="mobile" label="电话" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="wx_number" label="微信号" show-overflow-tooltip>
					<template slot-scope="scope">
						<div>{{scope.row.wx_number==''?'/':scope.row.wx_number}}</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="lx_num" label="联系次数" show-overflow-tooltip>
					<template slot-scope="scope">
						<div>{{scope.row.lx_num==''?'/':scope.row.lx_num+'次'}}</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="last_time" label="最后联系时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="cj_num" label="成交次数" show-overflow-tooltip>
					<template slot-scope="scope">
						<div>{{scope.row.cj_num==''?'/':scope.row.cj_num+'次'}}</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="salesman_name" label="业务员" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="add_time" label="创建时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="address" label="操作" width="300">
					<template slot-scope="scope">
						<el-button size="mini"
							style="background: #1E69FF;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
							round @click="ctrl_custom(scope.$index, scope.row,0)">成交</el-button>
						<el-button size="mini"
							style="background: #1E69FF;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
							round @click="openDetail(scope.$index, scope.row)">详情</el-button>
						<el-button size="mini"
							style="background: #1E69FF;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
							round @click="ctrl_custom(scope.$index, scope.row,1)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<footer class="d-flex j-sb a-center">
				<el-button size="mini" @click="admin_batch_great_custom_file"
					style="color: #000000; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;box-sizing: border-box;border: 2px solid #000000;"
					>下载客户表</el-button>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, total" :total="total_records">
				</el-pagination>
			</footer>
		</div>
	</div>
</template>

<script>
	import JSZip from '@/libs/jszip'
	export default{
		data(){
			return{
				hzhbShow:false,
				goods_id:'',
				curIndex:0,
				tableData:[],
				currentPage: 1, //初始页
				pageSize : 10,
				total_records : 0,
				status:'0',
				keyword:'',
				sp_data:[
					// {text:'全部',value:'0'},
					{text:'发至微信', value:'1'},
					{text:'发至邮箱', value:'2'},
					{text:'线下快递', value:'3'}
				],
				type:1,
				tabList:[
					{
						tabname:'总客户(人)',
						tabnum:0,
						tabstate:0
					},{
						tabname:'准客户(人)',
						tabnum:0,
						tabstate:1
					},{
						tabname:'客户(人)',
						tabnum:0,
						tabstate:2
					}
				],
				review_content:'',
				percent:0,
				try_id:'',
				checkId:[]
			}
		},
		methods:{
			tabclick(index){
				this.curIndex=index
				this.currentPage=1
				this.checkId=[]
				this.admin_get_customer_list()
			},
			/*获取顶部信息*/
			admin_get_customer_data(){
				let params = {
					act:'admin_get_customer_data',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.admin_get_customer_data(params).then((res)=>{
					if(res.code==0){
						this.tabList[0].tabnum=res.data.num_a
						this.tabList[1].tabnum=res.data.num_b
						this.tabList[2].tabnum=res.data.num_c
						this.percent=res.data.num_d
					}
				})
			},
			admin_get_customer_list(){
				let params = {
					act:'admin_get_customer_list',
					type:this.curIndex,
					keyword:this.keyword,
					page:this.currentPage,
					size:this.pageSize,
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.admin_get_customer_list(params).then((res)=>{
					this.tableData=[]
					this.total_records=0
					this.tableData = res.data
				})
			},
			handleSizeChange(size) {
				this.pageSize = size;
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.admin_get_customer_list()
			},
			handleSelectionChange(val) {
				let arr = []
				val.forEach((item)=>{
					arr.push(item.custom_id)
				})
				this.checkId=arr
			},
			isIE () {
				if (!!window.ActiveXObject || 'ActiveXObject' in window) {
					return true
				} else {
					return false
				}
			},
			admin_batch_great_custom_file(){
				if(this.checkId.length==0){
					this.$message({
						showClose: false,
						message:'请先选择需要生成客户表的客户',
						type: 'warning',
						offset: 350
					})
					return
				}
				let params={
					act:'admin_batch_great_custom_file',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					custom_ids: this.checkId.join(',')
				}
				this.$api.admin_batch_great_custom_file(params).then((res)=>{
					if(res.code==0){
						// var zip = new JSZip();
						// res.data.forEach((obj,index)=> {
						// 	console.log(obj);
						// 	// 把每个文件放入
						// 	zip.file('客户表'+(index+1)+'.docx', window.open(obj));
						// });
						// // 生成zip文件并下载
						// zip.generateAsync({ 
						//   type: 'blob'
						// }).then(function(content) {
						// 	// 下载的文件名
						// 	var filename = '客户表' + '.zip';
						// 	// 创建下载链接
						// 	var el= document.createElement('a');
						// 	el.download = filename;
						// 	el.style.display = 'none';
						// 	el.href = URL.createObjectURL(content);
						// 	document.body.appendChild(el);
						// 	el.click();
						// 	document.body.removeChild(el);
						// });
						if (this.isIE()) { // IE
							window.open(res.data, '_blank')
						} else {
							var filename = '客户表' + '.zip';
							// 创建下载链接
							var el= document.createElement('a');
							el.download = filename;
							el.style.display = 'none';
							el.href = res.data;
							document.body.appendChild(el);
							el.click();
							document.body.removeChild(el);
						}
					}
				})
			},
			ctrl_custom(index,row,type){
				this.$msgbox.confirm('是否确认此操作?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.admin_ctrl_custom(row,type)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});  
				})
			},
			admin_ctrl_custom(row,type){
				let params={
					act:'admin_ctrl_custom',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					custom_id:row.custom_id,
					type:type
				}
				this.$api.admin_ctrl_custom(params).then((res)=>{
					if(res.code==0){
						this.$message({
							showClose: false,
							message:type==0?'操作成交成功':'删除成功',
							type: 'success',
							offset: 350
						})
						if(type==0){
							this.admin_get_customer_data()
						}
						this.admin_get_customer_list()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			openDetail(index,row){
				this.$router.push({path:'cus_man_detail',query:row})
			},
			performance(){
				this.$router.push({path:'cus_man_list',query:''})
			}
		},
		created() {
			this.admin_get_customer_data()
			this.admin_get_customer_list()
		}
	}
</script>

<style scoped>
	.tab-active{
		color: #1E69FF;
		font-size: 14px;
	}
	.tab-pt{
		color: #000000;
		font-size: 14px;
	}
	.cld-box{
		position: absolute;
		bottom: 0;
		width: 40px;
		height: 2px;
		background: #1E69FF;
		transition: .3s all;
		bottom: -6px;
	}
	.on_sale_table{
		width: 100%;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.table {
		margin-top: 1.44rem;
		width: 87.5rem;
		height: 100%;
		background: #E6E9ED;
		overflow: hidden;
		padding: 1.25rem;
		border-radius: 0.375rem;
	}
	footer {
		width: 87.5rem;
		height: 3.85rem;
		background: #FFFFFF;
		padding: 0 1.25rem;
		box-sizing: border-box;
		border-radius:0 0 0.375rem 0.375rem;
	}
	.all{
		box-sizing: border-box;
		border:1px solid #205DFF;
		color: #205DFF;
		background-color: #FFFFFF;
	}
	.all-active{
		background-color: #205DFF;
		color: #FFFFFF;
		box-sizing: border-box;
	}
</style>